export const SCAN_REQUEST_SENT = 'Scan request has been sent.'
export const SCAN_ALL_REQUEST_SENT = 'Scan all request sent.'
export const ERROR_MESSAGE = 'Something went wrong.'
export const MISSING_REPORT_MESSAGE = 'Missing/Unavailable'
export const SUBSCRIPTION_ERROR = 'Something went wrong in processing your subscription.'
export const PLAN_SUBSCRIPTION_UPDATE = (plan: string) => {
  return `You're now on ${plan}!`
}
export const PREPARING_FILE = 'Preparing your file...'
